import axios from "axios";
import { Text } from "components";
import React, { useEffect, useState } from "react";
import Select from "react-select";
// import * as XLSX from 'xlsx';

import pdfMake from "pdfmake/build/pdfmake";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver"; // Install file-saver if you don't have it: npm install file-saver

import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  LabelList,
  Legend,
  Rectangle,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import CustomSelect from "components/SmallComponents/CustomSelect";

function TaxInvoiceAgaistSalesOrderReport() {
  const currentDate = new Date().toISOString().split("T")[0];
  const today = new Date();
  const formattedToday = today.toISOString().split("T")[0];
  const thirtyDaysAgo = new Date(today);
  thirtyDaysAgo.setDate(1); // Set to the first day of the current month
  thirtyDaysAgo.setMonth(thirtyDaysAgo.getMonth() - 1); // Go back one month
  const formattedThirtyDaysAgo = thirtyDaysAgo.toISOString().split("T")[0];

  const [timedateflag, setTimeDateFlag] = useState(false);
  const [salesOrderFlag, setSalesOrderFlag] = useState(false);
  const [customerSelectionFlag, setCustomerSelectionFlagFlag] = useState(false);
  // Get the date 30 days ago

  const [download, setDownload] = useState(false);
  const [salesOrder, setSalesOrder] = useState([]);
  const [salesOrderCode, setsalesOrderCode] = useState();
  const [salesOrderId, setSalesOrderId] = useState();
  const [customerList, setCustomerList] = useState([]);
  const [customerId, setCustomerId] = useState();

  const [toDate, setToDate] = useState(formattedToday);
  const [fromDate, setFromDate] = useState(formattedThirtyDaysAgo);
  const [showChart, setShowChart] = useState(false);
  const [flag, setFlag] = useState(false);
  const [resetkey, setResetKey] = useState(0);
  const [reportStatusFlag, setReportStatusFalg] = useState(true);

  const token = sessionStorage.getItem("token");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  // for getting salesOrder List...
  useEffect(() => {
    salesOrderGet();
  }, [fromDate, toDate, customerId, salesOrderId]);

  const obj = {
    start_date: fromDate,
    end_date: toDate,
    customer_id: customerId,
    sales_order_id: salesOrderId,
  };

  const salesOrderGet = () => {
    axios
      .post(
        "/api/purple-fusion/taxinvoiceagainst/salesorderreport/get/salesorder/details/all",
        obj,
        headers
      )
      .then((response) => {
        if (response.data.length == 0) {
          setReportStatusFalg(false);
        } else {
          setReportStatusFalg(true);
          setSalesOrder(response.data);
          console.log(response.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  //for getting custumer list ....
  useEffect(() => {
    setTimeout(() => {
      getCustomerList();
    }, 1000);
  }, []);

  const getCustomerList = () => {
    axios
      .post("/api/purple-fusion/revenuereport/get/customer", {}, headers)
      .then((response) => {
        setCustomerList(response.data);
      })
      .catch((error) => {
        console.error("Error in fetching company purchase items", error);
      });
  };
  //when flage is false then filteredPurchase object is shown in report after selecting the code ...
  const filteredPurchase = salesOrder.filter((purchase) => {
    return purchase.code === salesOrderCode;
  });

  //for resetting the code field
  useEffect(() => {
    setResetKey((prev) => prev + 1);
  }, [toDate, fromDate, customerId]);

  //for pdf and excel download title..(timeStapm)
  const [dateTime, setDateTime] = useState("");
  useEffect(() => {
    const currentTimestamp = new Date();
    const formattedDate = currentTimestamp
      .toLocaleDateString([], {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .replace(/\//g, "-");
    const formattedDateTime = `${formattedDate}`;
    setDateTime(formattedDateTime);
    console.log(formattedDateTime);
  }, [timedateflag]);

  const DownloadExcel = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("SalesOrder Vs TaxInvoice Report");
    const dataSource = flag === false ? salesOrder : filteredPurchase;
    const dateTime = new Date().toISOString().slice(0, 10); // Today's date

    // Format headers date
    const formatHeadersDate = (dateStr) => {
      const [year, month, day] = dateStr.split("-"); // Split the date string
      return `${day}-${month}-${year}`; // Return in DD-MM-YYYY format
    };

    // Add report title and date range at the top
    worksheet.addRow(["Report Name:", "SalesOrder Vs TaxInvoice Report"]);
    worksheet.addRow(["From Date:", formatHeadersDate(fromDate)]);
    worksheet.addRow(["To Date:", formatHeadersDate(toDate)]);
    if (customerSelectionFlag == true) {
      worksheet.addRow(["Customer Name:", salesOrder[0].customername]);
    } else {
      worksheet.addRow([]); // Empty row for spacing
    }
    if (salesOrderFlag == true) {
      worksheet.addRow(["Sales Order Code:", salesOrderCode]);
    } else {
      worksheet.addRow([]); // Empty row for spacing
    }
    worksheet.addRow([]); // Empty row for spacing

    // Define headers with 'SR.NO' and other columns
    const headers = [
      "Sr.No",
      "Customer Name",
      "Code",
      "Item Name",
      "Sales Order Qty",
      "Tax Invoice Qty",
      "Current Stock Qty",
    ];
    worksheet.addRow(headers);

    // Freeze the top 5 rows (title and header)
    worksheet.views = [{ state: "frozen", ySplit: 7 }];

    // Apply bold font and left alignment to the first 3 rows of column 1
    for (let i = 1; i <= 6; i++) {
      const cell = worksheet.getCell(i, 1); // Get cell in column 1
      cell.font = { bold: true }; // Make text bold
    }
    // Apply styles to the header row (5th row)
    worksheet.getRow(7).eachCell({ includeEmpty: true }, (cell) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } }; // white text color
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF368BC1" }, // blue background color
      };
      cell.alignment = { horizontal: "center", vertical: "middle" };
    });
    // Apply styles to the first 4 rows (title and date rows)
    for (let i = 1; i <= 6; i++) {
      const row = worksheet.getRow(i);
      row.eachCell({ includeEmpty: true }, (cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFFFFFF" }, // white background
        };
      });
    }
    // Remove gridlines for the first 4 rows by setting the fill to match the background
    for (let i = 1; i <= 6; i++) {
      for (let j = 1; j <= headers.length; j++) {
        const cell = worksheet.getRow(i).getCell(j);
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFFFFFF" }, // white background
        };
      }
    }
    // Add data to worksheet as arrays with numeric values
    dataSource.forEach((revenue, index) => {
      worksheet.addRow([
        index + 1,
        revenue.customername,
        revenue.code,
        revenue.item_name,
        Number(revenue.sales_order_item_quantity), // Convert to number
        Number(revenue.tax_invoice_quantity), // Convert to number
        Number(revenue.stock_transaction_item_quantity), // Convert to number
      ]);
    });

    // Save the workbook
    workbook.xlsx
      .writeBuffer()
      .then((buffer) => {
        saveAs(
          new Blob([buffer]),
          `SalesOrder Vs TaxInvoice Report ${dateTime}.xlsx`
        );
      })
      .catch((error) => {
        console.error("Error saving Excel file:", error);
      });
  };

  // Custom tooltip component
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const data = payload[0] ? payload[0].payload : {};
      return (
        <div
          className="custom-tooltip"
          style={{
            backgroundColor: "white",
            padding: "5px",
            border: "1px solid #ccc",
          }}
        >
          <p>{`Customer Name: ${data.customername}`}</p>
          {flag === false && <p>{`Sales Order: ${data.code}`}</p>}
          <p>{`Item: ${label || "N/A"}`}</p>
          <p>{`Sales Order Qty: ${data.sales_order_item_quantity}`}</p>
          <p>{`Tax Invoice Qty: ${data.tax_invoice_quantity}`}</p>
          <p>{`Stock Qty: ${data.stock_transaction_item_quantity}`}</p>
          <p>{`Completed(%): ${
            (
              (data.tax_invoice_quantity / data.sales_order_item_quantity) *
              100
            ).toFixed(1) + "%" || "N/A"
          }`}</p>
        </div>
      );
    }
    return null;
  };

  // Custom Bar Component for combine sales_order_qty and Tax_invoice_qty
  const CustomBar = (props) => {
    const { x, y, width, height, fill, payload } = props;
    const salesQuantity = payload.sales_order_item_quantity;
    const taxQuantity = payload.tax_invoice_quantity;
    // Calculate the width of the tax invoice portion
    const taxWidth = (width * taxQuantity) / salesQuantity;

    // Calculate the percentage
    const percentage = ((taxQuantity / salesQuantity) * 100).toFixed(1);

    return (
      <g>
        {/* Main bar for sales_order_item_quantity */}
        <rect x={x} y={y} width={width} height={height} fill={fill} />
        {/* Overlay bar for tax_invoice_quantity */}
        {taxQuantity > 0 && (
          <rect x={x} y={y} width={taxWidth} height={height} fill="#82ca9d" />
        )}

        {/* Percentage text at the start of the bar */}
        <text
          x={x + 50} // Slight offset to avoid touching the bar's edge
          y={y + height / 2}
          textAnchor="start" // Align text to the start
          dominantBaseline="middle"
          fill="#000"
          fontSize="12px"
        >
          {percentage}%
        </text>
      </g>
    );
  };
  //show bar as per max value
  const data = flag === false ? salesOrder : filteredPurchase;
  const maxValue = Math.max(
    ...data.map((item) => item.sales_order_item_quantity)
  );

  return (
    <>
      <div className="w-full flex flex-col border rounded-md">
        <div className="flex justify-between items-start my-1 mx-3 gap-1">
          <div className="flex flex-row items-center w-full">
            <Text className="text-sm md:text-[22px] text-gray-600  sm:text-xl pt-2 mr-2 ml-2 mb-2 ">
              Form
            </Text>
            <input
              name="from_date"
              type="date"
              value={fromDate}
              onChange={(e) => {
                setFromDate(e.target.value);
              }}
              className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] text-sm "
            />
            <Text className="text-sm md:text-[22px] text-gray-600  sm:text-xl pt-2 mr-2 ml-2 mb-2 ">
              To
            </Text>

            <input
              max={currentDate} // Restrict to current date
              name="to_date"
              type="date"
              value={toDate}
              onChange={(e) => {
                setToDate(e.target.value);
              }}
              className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] text-sm"
            />

            <CustomSelect
              options={[
                { label: "All Customer", value: "" },
                ...customerList.map((customer) => ({
                  label: customer.name,
                  value: customer.id,
                })),
              ]}
              className="bg-white-A700 border border-gray-200_02 border-solid h-9 ml-2 rounded-md w-[20%] text-sm"
              onChange={(selectedOption) => {
                setCustomerId(selectedOption.value);

                if (selectedOption.value === "") {
                  setCustomerSelectionFlagFlag(false);
                } else {
                  setCustomerSelectionFlagFlag(true);
                }
              }}
              placeholder="All Customer"
            />

            <CustomSelect
              options={[
                { label: " All Sales Order", value: "" },
                ...Array.from(
                  new Set(salesOrder.map((purchase) => purchase.code))
                ).map((code) => ({
                  label: code,
                  value: code,
                })),
              ]}
              className="bg-white-A700 border border-gray-200_02 border-solid h-9 ml-2 rounded-md w-[25%] text-sm"
              onChange={(selectedOption) => {
                if (
                  selectedOption.value == "all" ||
                  selectedOption.value == ""
                ) {
                  setFlag(false);
                } else {
                  setFlag(true);
                }
                setsalesOrderCode(selectedOption.value);
                setShowChart(true);

                if (selectedOption.value === "") {
                  setSalesOrderFlag(false);
                } else {
                  setSalesOrderFlag(true);
                }

                // setFlag(true)
              }}
              placeholder="Select Sales Order"
              key={resetkey}
            />
          </div>
          <div className="flex items-center ">
            <div
              className="flex flex-col relative z-20 "
              onMouseEnter={() => setDownload(true)}
              onMouseLeave={() => setDownload(false)}
            >
              <button
                id="dropdownDefaultButton"
                data-dropdown-toggle="dropdown"
                className="text-white-A700 bg-blue-700 hover:bg-blue-800 font-medium rounded-lg text-sm px-3 py-1.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 w-28 mr-4 "
                type="button"
              >
                {"Download"} &nbsp;
                <svg
                  className="w-2.5 h-2.5 ms-3"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 10 6"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m1 1 4 4 4-4"
                  />
                </svg>
              </button>
              <div
                className={`${
                  download ? "absolute top-[32px]" : "hidden"
                } z-20 bg-white divide-y divide-gray-100 rounded-lg shadow w-[110px] bg-white-A700  dark:bg-gray-700`}
              >
                <ul
                  className="py-0 text-sm text-gray-700 dark:text-gray-200"
                  aria-labelledby="dropdownDefaultButton"
                >
                  <li>
                    <a
                      className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                      onClick={() => DownloadExcel()}
                    >
                      Excel
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {reportStatusFlag == true && (
          <div className="w-[96%] h-full flex-col m-4 p-4 mr-20 overflow-scroll border-2">
            <ResponsiveContainer width="100%" height={350}>
              <BarChart
                layout="vertical"
                data={data}
                margin={{
                  top: 5,
                  right: 30,
                  bottom: 3,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <Legend
                  verticalAlign="bottom"
                  wrapperStyle={{ fontSize: "10px" }}
                />
                <ReferenceLine x={0} stroke="#000" />
                <XAxis
                  type="number"
                  tickFormatter={(value) => {
                    if (value >= 1000000) {
                      return `${(value / 1000000).toFixed(1)}M`;
                    } else if (value >= 100000) {
                      return `${(value / 100000).toFixed(1)}L`;
                    } else if (value >= 1000) {
                      return `${(value / 1000).toFixed(1)}K`;
                    } else {
                      return value.toFixed(0);
                    }
                  }}
                  tick={{ fontSize: "12px" }}
                  label={{
                    style: { fontSize: "12px" },
                  }}
                  domain={[0, maxValue * 1.1]} // Sets domain based on maxValue
                />
                <YAxis
                  type="category"
                  dataKey="item_name"
                  tickFormatter={(itemName) => itemName.slice(0, 100)} // Shortens item name
                  tick={{
                    fontSize: "10px",
                    textAnchor: "middle",
                    angle: 0,
                    dy: 0,
                    dx: -150,
                  }}
                  width={320}
                />
                <Tooltip
                  content={<CustomTooltip />}
                  wrapperStyle={{ fontSize: "10px" }}
                />
                <Bar
                  dataKey="sales_order_item_quantity"
                  name="Sales Order Quantity"
                  fill="#8884d8"
                  barSize={40}
                  shape={<CustomBar />}
                >
                  <LabelList
                    dataKey="sales_order_item_quantity"
                    position="right"
                    formatter={(value) => Number(value).toFixed(2)}
                    style={{ fontSize: "12px" }}
                  />
                </Bar>
              </BarChart>
            </ResponsiveContainer>
            {flag == true && (
              <div className="flex flex-row justify-center items-center mt-3">
                <h1 className="font-bold text-sm">Customer Name:</h1>
                <h1 className=" mr-4 text-sm">
                  {filteredPurchase[0]?.customername}
                </h1>
                <h1 className="font-bold text-sm">Sales Order:</h1>
                <h1 className="text-sm">{filteredPurchase[0]?.code}</h1>
              </div>
            )}
          </div>
        )}

        {reportStatusFlag == false && (
          <div class="flex items-start justify-center min-h-screen bg-gray-100">
            <div class="bg-white shadow-lg rounded-lg p-6 max-w-sm w-full mt-20">
              <div class="text-center text-gray-600 text-lg font-semibold">
                No Reports Available
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default TaxInvoiceAgaistSalesOrderReport;
